import { render, staticRenderFns } from "./investment.vue?vue&type=template&id=1bd49110&scoped=true&"
import script from "./investment.vue?vue&type=script&lang=js&"
export * from "./investment.vue?vue&type=script&lang=js&"
import style0 from "./investment.vue?vue&type=style&index=0&id=1bd49110&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd49110",
  null
  
)

export default component.exports